import React, { useEffect, useState } from "react";

const RemarkTable = ({ data, path, from }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const totalPages = Math.ceil(data.length / pageSize);

  const heads = [
    "8TYPE_OF_FAILUR",
    "9FAILUR_DATE_TIMEFROM",
    "10FAILUR_DATE_TIMETO",
    "11DURATION",
    "COA_SECTION",
    "BLOCK_SECTION_STATION",
    "UP_DOWN",
    "AVARAGE_DET_TOTAL_TIME",
    "SHIFT",
    "SECTION_NAME",
  ];

  const paginatedData = data.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [path, data]);
  const getPageNumbers = () => {
    let startPage = Math.max(1, currentPage - 1);
    let endPage = Math.min(totalPages, startPage + 2);

    if (endPage - startPage < 2) {
      startPage = Math.max(1, endPage - 2);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div>
      {data && (
        <div>
          <h6 className="bg-dark text-white p-1">
            {" "}
            Remarks as par assets failure{" "}
          </h6>
          <div className="d-flex justify-content-between">
            <h6 style={{ fontSize: "14px" }}>
              {path.F_YEAR}
              {path.ASSET_GROUP && `> ${path.ASSET_GROUP}`}{" "}
              {path.MAIN_CAUSE_DESC && `> ${path.MAIN_CAUSE_DESC}`}
              {path.SUB_CAUSE_DESC && ` > ${path.SUB_CAUSE_DESC}`}{" "}
              {path.SECTION_NAME && ` > ${path.SECTION_NAME}`}
            </h6>
            <div>
              <div className="mb-1">
                <b style={{ fontSize: "12px" }}>Cause: {data.length}</b>
                <button
                  className="btn btn-sm btn-outline-dark mx-1"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                {getPageNumbers().map((page) => (
                  <button
                    key={page}
                    className={`btn btn-sm mx-1 ${
                      page === currentPage ? "btn-dark" : "btn-outline-dark"
                    }`}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </button>
                ))}

                <button
                  className="btn btn-sm btn-outline-dark mx-1"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          </div>

          <div
            className="table-responsive"
            style={{
              minHeight: from === "OverView" ? "500px" : "720px",
              maxHeight: from === "OverView" ? "760px" : "720px",
              overflowY: "auto",
            }}
          >
            <table className="table newUiTable table-hover table-striped">
              <thead style={{ fontSize: "10px" }}>
                <tr className="table-dark">
                  <th>Sno</th>
                  {heads.map((key, index) => (
                    <th
                      key={index}
                      className="text-wrap "
                      style={{ minWidth: "80px" }}
                    >
                      {key
                        .replace("_", " ")
                        .replace("_", " ")
                        .replace("_", " ")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody style={{ fontSize: "12px" }}>
                {paginatedData.map((obj, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * pageSize + index + 1}</td>
                    {heads.map((headKey, i) => (
                      <td key={i} className="text-wrap">
                        {headKey === "9FAILUR_DATE_TIMEFROM" ||
                        headKey === "10FAILUR_DATE_TIMETO"
                          ? `${obj[headKey]?.slice(0, 10)} ${obj[
                              headKey
                            ]?.slice(11, 19)}`
                          : headKey === "SHIFT"
                            ? obj[headKey].replace("_", "-")
                            : obj[headKey]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-center mt-2">
            <button
              className="btn btn-sm btn-outline-dark mx-1"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            {getPageNumbers().map((page) => (
              <button
                key={page}
                className={`btn btn-sm mx-1 ${
                  page === currentPage ? "btn-dark" : "btn-outline-dark"
                }`}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            ))}

            <button
              className="btn btn-sm btn-outline-dark mx-1"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RemarkTable;
